var _defs, _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.001,
    viewBox: "0 0 18 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .tag-icon-a,\n            .tag-icon-b {\n                fill: #35393b;\n            }\n\n            .tag-icon-a {\n                opacity: 0;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "tag-icon-a",
    width: 18,
    height: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tag-icon-b",
    d: "M4.358,2.433A1.937,1.937,0,0,0,2.425,4.356h0A1.93,1.93,0,0,0,4.349,6.288h0a1.927,1.927,0,0,0,.006-3.855m0,2.837h0a.9.9,0,0,1-.9-.908l-.084-.006h.084a.908.908,0,0,1,.906-.9H4.36A.907.907,0,0,1,4.354,5.27",
    transform: "translate(-0.408 -0.41)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tag-icon-b",
    d: "M17.655,9.459,8.761.16A.512.512,0,0,0,8.394,0H.507A.508.508,0,0,0,0,.51V8.036a.506.506,0,0,0,.144.313l9.1,9.3A1.233,1.233,0,0,0,10.1,18a.08.08,0,0,1,.02,0,1.2,1.2,0,0,0,.853-.353l6.669-6.669A1.094,1.094,0,0,0,18,10.21a1.079,1.079,0,0,0-.345-.751M1.017,1.018H8.172l8.741,9.136.051.064c-.01.011-.022.025-.038.042l-6.665,6.668a.233.233,0,0,1-.149.057.191.191,0,0,1-.145-.052L1.017,7.784Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.42485e6c.svg";
export { ForwardRef as ReactComponent };